import { render, staticRenderFns } from "./ConfigurationEmployee.vue?vue&type=template&id=675e3789&scoped=true&"
import script from "./ConfigurationEmployee.vue?vue&type=script&lang=js&"
export * from "./ConfigurationEmployee.vue?vue&type=script&lang=js&"
import style0 from "./ConfigurationEmployee.vue?vue&type=style&index=0&id=675e3789&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "675e3789",
  null
  
)

export default component.exports